import React, { useState } from 'react'

import { firestore } from '../../firebase';

function EditLoanProvider({currentBank}) {

    const [bank, setBank] = useState(currentBank.bank);
    const [rente, setRente] = useState(currentBank.rente);
    const [type, setType] = useState(currentBank.rente_type);

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const loanRef = firestore.collection("renter").doc(currentBank.id);
            const data = {
                bank,
                rente: +rente,
                rente_type: type
            }
            loanRef.update(data);
            setMessage("Oppdatert")
        } catch (error) {
            console.log(error)
            setError("Kunne ikke oppdatere")
        }
    }

    return (
        <form onSubmit={submitHandler}>
            <h4 className="mt-4 font-weight-bold">Rediger {bank} {type}</h4>
            <label>Bank</label>
            <input className="form-control mb-2" value={bank} onChange={e => setBank(e.target.value)} />

            <label>Rente</label>
            <input type="number" step="0.01" className="form-control mb-2" value={rente} onChange={e => setRente(e.target.value)} />

            <label>Type</label>
            <input className="form-control mb-2" value={type} onChange={e => setType(e.target.value)} />
            {error && <div className="alert alert-danger">{error} <span className="float-right" onClick={() => setError("")}>Lukk</span></div>}
            {message && <div className="alert alert-success">{message} <span className="float-right" onClick={() => setMessage("")}>Lukk</span></div>}
            <button className="btn btn-block btn-success">Lagre</button>

        </form>
    )

}
export default EditLoanProvider